import { render, staticRenderFns } from "./product-variants.vue?vue&type=template&id=fdc46894&"
import script from "./product-variants.vue?vue&type=script&lang=js&"
export * from "./product-variants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports